module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAQBJREFUSEu1kwENwjAQRV8dIAEJOAAJOAAJIAEHSJgEcIAEcIAEHIz8pZd03cqODposy67tu3+3fwGgbdtW7zkrhBDS+92HwPmGN4mJmgTPVW8JBor/Dq5pTRR1BJqQ92hMsSX5VI3OJPsnF1g/0lNBFdgDrwZ7LQj4WxGhd+AFLONTyuUGC3gF1pEk+BPYFhK4wDdgAaxG5F1iXBWkywVugL3dymylcG8/npsE99SmlkscUA3elKwW4Uqu1Z2rUmwJsgmsUjzo4a96LLB5Ny3VSpYrFJdrvnaFwdVLs5x8/AB2kz6OEyVInj1VoqHQ45+80mxWxjsfS+GhElC6dn4D1mHtAa14B98AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/images/document_uploader_icon.png
// module id = 3846
// module chunks = 0